import React, { useState } from 'react';
import styled from '@emotion/styled';

function MailForm(props) {
  const [formData, setData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSuccess, setSuccess] = useState(false);
  const [isSubmitting, setSubmitting] = useState(false);
  const [dirty, setDirty] = useState([]);
  const [validation, setValidation] = useState({
    name: '',
    email: '',
    message: '',
  });
  const errors = Object.values(validation);
  const hasErrors = validation.name || validation.email || validation.message;

  const handleFocus = e => {
    setDirty([...dirty, e.target.name]);

    setValidation({
      ...validation,
      [e.target.name]: '',
    });
  };

  const handleBlur = (e, checkEmail) => {
    if (checkEmail && e.target.name === 'email') {
      return new Promise((resolve, reject) => {
        return fetch(
          `https://emailverification.whoisxmlapi.com/api/v1?apiKey=at_r9VQiFycrlbe1DqQeXgY5rrHxRSXO&emailAddress=${e.target.value}`
        )
          .then(response => {
            if (response.ok) {
              return response.json()
            } else {
              reject();
              setValidation({
                ...validation,
                email: 'Is your email correct?',
              });
            }
          })
          .then(({ formatCheck, smtpCheck, dnsCheck, disposableCheck }) => {
            if (
              formatCheck === 'false' ||
              smtpCheck === 'false' ||
              dnsCheck === 'false' ||
              disposableCheck === 'true'
            ) {
              reject();
              console.log('REJECT!', smtpCheck)
              setValidation({
                ...validation,
                email: 'Is your email correct?',
              });
            } else {
              console.log('OK!', smtpCheck)
              setValidation({
                ...validation,
                email: '',
              });
              resolve();
            }
          })
          .catch(e => {
            reject();
            setValidation({
              ...validation,
              email: 'Is your email correct?',
            });
          });
      });  
    }

    return new Promise((resolve, reject) => {
      switch (e.target.name) {
        case 'name': {
          if (!dirty.includes('name')) {
            reject();
            break;
          }

          if (dirty.includes('name') && (!e.target.value || e.target.value.length < 2)) {
            setValidation({
              ...validation,
              name: "What's your name?",
            });
            reject();
            break;
          } else {
            setValidation({
              ...validation,
              name: '',
            });
            resolve();
            break;
          }
        }
        case 'email': {
          if (!checkEmail && !dirty.includes('email')) {
            reject();
            break;
          }

          if (!checkEmail && (!e.target.value || e.target.length < 6)) {
            setValidation({
              ...validation,
              email: 'Is your email correct?',
            });
            reject();
            break;
          }

          break;
        }
        case 'message': {
          if (!e.target.value || (e.target.value.length < 5 && dirty.includes('message'))) {
            setValidation({
              ...validation,
              message: 'Tell me something/more?',
            });
            reject();
            break;
          } else {
            setValidation({
              ...validation,
              message: '',
            });
            resolve();
            break;
          }
        }
        default: {
          break;
        }
      }
    })
      .catch(() => console.error('Form is invalid :('));
  };

  const handleChange = e => {
    const data = {
      ...formData,
      [e.target.name]: e.target.value,
    };
    setData(data);
  };

  const handleError = () => {
    setSubmitting(false);
  };

  const handleSubmit = async e => {
    e.preventDefault();

    setSubmitting(true);

    Promise.all(Object.keys(formData).map(key => {
      return handleBlur({
        target: {
          name: key,
          value: formData[key],
        },
      }, true);
    }))
      .then(() => {
        fetch('/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: encode({ 'form-name': 'contact', ...formData }),
        })
          .then(() => {
            setSuccess(true);

            setTimeout(() => {
              props.handleToggle(false);
            }, 1600);
          })
          .catch(handleError);
      })
      .catch(handleError);    
  };

  return (
    <Wrap
      onSubmit={handleSubmit}
      name="contact"
      method="post"
      data-netlify="true"
      netflify="true"
      dataNetlify="true"
      netlifyHoneypot="bot-field"
      dataNetlifyHoneypot="bot-field"
      data-netlify-honeypot="bot-field"
      isSuccess={isSuccess}>
      <FormWrap
        isSubmitting={isSubmitting || isSuccess}>
        <input type="hidden" name="form-name" value="contact" />
        <input name="bot-field" style={{ display: 'none' }} onChange={handleChange} />
        <div>
          <Input
            type="text"
            name="name"
            placeholder="Your name"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            isError={validation.name}
            required
          />
          <Input
            type="email"
            name="email"
            placeholder="Your email"
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChange}
            isError={validation.email}
            required
          />
        </div>
        <Input
          as="textarea"
          name="message"
          placeholder="Say hello"
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          isError={validation.message}
          required></Input>

        {hasErrors && (
          <p>
            {errors.map(msg => {
              return `${msg} `;
            })}
          </p>
        )}

        {!hasErrors &&
          <p>
            You can also email me at&nbsp;<a href="mailto:mail@ezekielaquino.com" style={{ textDecoration: 'underline' }}>mail@ezekielaquino.com</a>
          </p>
        }

        <button type="submit">
          {isSubmitting ? (isSuccess ? '✿ SUCCESS ✿' : 'SENDING') : 'SEND'}
        </button>
      </FormWrap>
    </Wrap>
  );
}

function encode(data) {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

const Wrap = styled.form`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding: calc(4rem + 20px) 1rem calc(0.5rem + 6px) 1rem;
  animation: ${props => props.isSuccess && `successAnimation 1s forwards cubic-bezier(0.77, 0, 0.175, 1)`};
  animation-delay: 0.5s;

  &:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    background: var(--textColor);
    opacity: 0.9;
    top: 0;
    left: 0;
  }

  button {
    background-color: ${props => props.isSuccess && '#26b35e'};
    border-color: ${props => props.isSuccess && '#ffffff'};
    color: ${props => props.isSuccess && '#ffffff'};
  }
`;

const FormWrap = styled.div`
  width: 100%;
  height: 100%;
  pointer-events: ${props => props.isSubmitting && 'none'};
  opacity: ${props => props.isSubmitting && '0.75'};
  display: flex;
  flex-direction: column;
  transition: opacity 0.5s cubic-bezier(0.77, 0, 0.175, 1);

  > div {
    flex-grow: 0;
  }

  input,
  textarea,
  button {
    width: 100%;
    max-width: 430px;
    display: block;
    margin: 0 auto 0.5rem auto;
    border-radius: 2rem;
    border: var(--borderWidth) solid var(--bgColor);
    height: 2rem;
    padding: 0 10px;
    font: inherit;
    background: 0;
    text-transform: inherit;
    color: inherit;
    outline: none;
    position: relative;
    appearance: none;

    ::placeholder {
      color: var(--bgColor);
    }
  }

  textarea {
    flex-grow: 1;
    margin-bottom: 0;
    resize: none;
    border-radius: 1.3rem;
    padding-top: 10px;
  }

  button {
    margin-bottom: 0;
    cursor: pointer;
    display: inline-block;
    min-width: 200px;

    &[disabled] {
      opacity: 0.4;
      cursor: default;
    }
  }

  p {
    position: relative;
    height: 2rem;
    padding: 0 10px;
    margin: 10px auto;
    display: flex;
    align-items: center;
    font-size: 0.8rem;
  }
`;

const Input = styled.input`
  background: ${props => props.isError && 'var(--bgColor)'} !important;
  color: ${props => props.isError && 'var(--textColor)'} !important;
  ::placeholder {
    color: ${props => props.isError && 'var(--textColor)'} !important;
  }
`;

export default MailForm;
